export default {
    errors: {
        order_already_returned: "รายการสั่งซื้อถูกตีกลับไปแล้ว",
		no_orders : "ไม่พบสินค้า",
        db_query_failed: "เชื่อมต่อฐานข้อมูลผิดพลาด",
        db_fetch_failed: "การอ่านข้อมูลจากฐานข้อมูลผิดพลาด",
        permission_denied: "คุณไม่มีสิทธิ์เข้าใช้งานระบบนี้",
        invalid_param: "ข้อมูลที่ระบุไม่ถูกต้อง",
		internal: "เกิดข้อผิดพลาดภายในระบบ",
		payment_method_not_found:"ไม่พบช่องทางการซื้อ",
		inventory_not_found :"ไม่พบสินค้าในคลังสินค้า",
		invalid_tracking_number:"หมายเลขพัสดุไม่ถูกต้อง",
		orders:{
			not_found:"ไม่พบรายการสั่งซื้อ",
			map_product:"สินค้ายังไม่เชื่อมต่อกับคลังสินค้า",
			invalid_date_range: "กรุณาระบุช่วงวันที่ไม่เกิน 31 วัน",
		},
        user: {
            duplicate: "ข้อมูลผู้ใช้งานซ้ำ",
            duplicate_username: "ข้อมูลผู้ใช้งานซ้ำ",
            duplicate_email: "ข้อมูลอีเมล์ซ้ำ",
            blcok_delete_by_self: "ไม่สามารถลบข้อมูลตนเองได้",
            fail: "การปรับปรุงข้อมูลผู้งานผิดพลาด",
            email_wrong_format: "รูปแบบอีเมล์ไม่ถูกต้อง",
            enterprise_empty: "กรุณาระบุองค์กร"
        },
        auth: {
            login_fail: "เข้าสู่ระบบผิดพลาด",
            block: "ผู้ใช้งานถูกระงับ",
            login_success: "เข้าสู่ระบบสำเร็จ",
            logout_success: "ออกจากระบบสำเร็จ",
            unauthoriezed: "เข้าสู่ระบบผิดพลาด",
            reset_invalid_token: "token ไม่ถูกต้อง",
            reset_token_expired: "token หมดอายุ",
            forgot_password_fail: "ลืมรหัสผ่านไม่สำเร็จ",
            reset_password_fail: "เปลี่ยนรหัสผ่านไม่สำเร็จ",
            username_wrong_format: "รูปแบบของชื่อผู้ใช้งานไม่ถูกต้อง",
            password_wrong_format: "รูปแบบของรหัสผ่านไม่ถูกต้อง",
            token: "Toekn ไม่ถูกต้อง",
            password: "รหัสผ่านไม่ถูกต้อง",
            password_confirm: "การยืนยันรหัสผ่านไม่ถูกต้อง"
        },
        profile: {
            change_profile_failed: "แก้ไขข้อมูลผิดพลาด",
            change_password_failed: "แก้ไขรหัสผ่านผิดพลาด",
            password_confirm_not_match: "การยืนยันรหัสผ่านไม่ถูกต้อง",
            password_confirm_wrong_format: "รูปแบบรหัสผ่านไม่ฟถูกต้อง",
            password_old_wrong: "รหัสผ่านเดิมไม่ถูกต้อง"
        },
        wms: {
            inventory_create_fails: "สร้างคลังสินค้าผิดพลาด",
            inventory: {
                balance_not_enough: "สินค้าคงเหลือไม่เพียงพอ"
            }
        },
		wh:{

		},
		packing:{
			invalid_order_status : "สถานะออเดอร์ไม่ถูกต้อง",
			goods_is_added: "สินค้าถูกเพิ่มเข้าระบบครบแล้ว",
			goods_not_enough: "สินค้าไม่เพียงพอ",
		}
    },

    bc_portal: "Web Portal",
    bc_package: "แพ็คเกจ",
    bc_voicemail: "ข้อความเสียง",
    bc_report: "ข้อมูลการโทร",
    bc_user: "ผู้ใช้งาน",
    bc_corporate: "องค์กร",
    bc_mlhg: "กลุ่ม Hunt",
    bc_pilot_number: "หมายเลของค์กร",
    bc_agent_number: "หมายเลขผู้ใช้งาน",
    bc_change_profile: "ข้อมูลส่วนตัว",
    bc_change_password: "เปลี่ยนรหัสผ่าน",
    bc_admin: "ผู้ดูแลระบบ",
    bc_platform_connect: "เชื่อมต่อกับแพลตฟอร์ม",
    bc_coupon: "คูปองส่วนลด",
    bc_coupon_detail: "รายการคูปองส่วนลด",

    profile: {
        profile: "ข้อมูลส่วนตัว",
        info: "ข้อมูลส่วนตัว",
        name: "ชื่อ",
        lname: "นามสกุล",
        phone: "เบอร์โทรศัพท์",
        email: "อีเมล์",
        change_password: "เปลี่ยนรหัสผ่าน",
        password_old: "รหัสผ่านเดิม",
        password_new: "รหัสผ่านใหม่",
        password_confirm: "ยืนยันรหัสผ่าน",
        change_profile_success: "แก้ไขข้อมูลส่วนตัวสำเร็จ",
        change_password_success: "เปลี่ยนรหัสผ่านสำเร็จ"
    },
    menu: {
        user: "ผู้ใช้งาน",
        member: "สมาชิก",
		admin: "ผู้ดูแลระบบ",
		admin_product: "สินค้าและโปรโมชั่น",
		admin_platform_connect: "เชื่อมต่อระบบ",
		admin_skurandom: "สินค้าสุ่ม",
		sale_channel: "ช่องทางการขาย",
		product: "สินค้า",
		team: "ทีมขาย",
		order_status: "สถานะ",
		po: "ใบสั่งซื้อ",
		coupon: "คูปอง",
    },
    auth: {
		unverify: "ผู้ใช้งานยังไม่ได้ยืนยันตัวตน",
        block: "ผู้ใช้งานถูกระงับ",
        signin: "เข้าสู่ระบบ",
        signout: "ออกจากระบบ",
        username: "อีเมล์หรือชื่อผู้ใช้งาน",
        email: "อีเมล์",
        password: "รหัสผ่าน",
        forgetpassword: "ลืมรหัสผ่าน",
        resetpassword: "รีเซ็ตพาสเวิร์ด",
        confirm_reset_password: "ยืนยันการรีเซ็ตพาสเวิร์ดหมายเลข ",
        forgot_password_success: "ลืมรหัสผ่านสำเร็จ กรุณาตรวจสอบอีเมล์",
        reset_password_success: "เปลี่ยนรหัสผ่านสำเร็จ"
    },

    user: {
        create: "สร้างผู้ใช้งาน",
        name: "ชื่อ",
        username: "ชื่อผู้ใช้",
        phone: "เบอร์โทรศัพท์",
        role: "ระดับผู้ใช้งาน",
        type: "ประเภทผู้ใช้งาน",
        create_success: "สร้างผู้ใช้งานสำเร็จ",
        create_fail: "สร้างผู้ใช้งานไม่สำเร็จ"

    },
    name: "ชื่อ",
    description: "คำอธิบาย",
    location_x: "ตำแหน่ง (X)",
    location_y: "ตำแหน่ง (Y)",
    group_name: "ชื่อกลุ่ม",
    email: "อีเมล์",
    email_optional: "อีเมล์ (ไม่ระบุ)",
    created: "วันที่สร้าง",
    payment_at: "วันที่ชำระเงิน",
    search: "ค้นหา",
    save: "บันทึก",
    back: "กลับ",
    new: "สร้าง",
    status: "สถานะ",
    download: "ดาวน์โหลด",
    downloadall: "ดาวน์โหลดทั้งหมด",
    product_search: "ค้นหาสินค้า",
    welcome: "ยินดีต้อนรับ",
    myprofile: "ข้อมูลส่วนตัว",
    changepassword: "เปลี่ยนรหัสผ่าน",
    page_notfound: "ขออภัย ไม่พบหน้าที่คุณต้องการ",
    page_notfound_desc:
        "หน้าดังกล่าวอาจมีการเปลี่ยนแปลง ชื่อ หรือ URL ไม่ถูกต้อง กรุณาตรวจสอบลิงค์ที่คุณเข้ามาอีกครั้ง",
    actions: "เมนู",
    data: "ข้อมูล",
    to: "ถึง",
    of: "จาก",
    row_select: "ข้อมูลที่ถูกเลือก",
    yes: "ใช่",
    no: "ไม่ใช่",
    ok: "ตกลง",
    cancel: "ยกเลิก",
	confirm_cancel: "ยืนยันการยกเลิก",
    upload_file: "เพิ่มไฟล์",
    bg_admin: "ตั้งค่าผู้ดูแลระบบ",
    comportal: "ตั้งค่าผู้ใช้งาน",
    add: "เพิ่ม",
    close: "ปิด",
    please_select: "กรุณาเลือก",
	please_select_payment_method_type:"กรุณาเลือกประเภทการชำระเงิน",
	please_select_sale_channel_type:"กรุณาเลือกประเภทช่องทางการขาย",
	please_select_shipping_provider_type:"กรุณาเลือกบริษัทขนส่ง",
    create: "สร้าง",
    confirm: "ยืนยัน",
    create_success: "สร้างข้อมูลสำเร็จ",
    delete_confirm: "ยืนยันการลบข้อมูล",
    delete_confirm_text: "คุณต้องการลบข้อมูล ",
    delete_confirm_question: "คุณต้องการลบข้อมูล ",
    delete_success: "ลบข้อมูลสำเร็จ",
    delete_fail: "ลบข้อมูลไม่สำเร็จ",
    edit_success: "แก้ไขข้อมูลสำเร็จ",
    edit_fail: "แก้ไขข้อมูลไม่สำเร็จ",
    update_success: "แก้ไขข้อมูลสำเร็จ",
    update_fail: "แก้ไขข้อมูลไม่สำเร็จ",

    // Inventory
    inventory_transfer: "เบิกสินค้าจากคลังหลัก",
    inventory_transfer_to_line: "เบิกสินค้าเข้าสายแพ็ค",
    inventory_out: "เบิกสินค้า",
    inventory_in: "นำเข้าสินค้า",

	phone: "เบอร์โทรศัพท์",

    // =================================================================
    // WMS Module
    // =================================================================
    wms: {
        name: "ระบบคลังสินค้า",
        menu: {
            inventory: "คลังสินค้า",
            inventory_dashboard: "Dashboard",
            inventory_list: "รายการสินค้าคงเหลือ",
            inventory_list_detail: "รายการสินค้าคงเหลือแยกตามคลัง",
			inventory_history_product_list: "ประวัติรายการสินค้า",
			inventory_history_storage_list: "รายการสรุปคลังสินค้า",
            inventory_history: "ประวัติคลังสินค้า",
            inventory_summary_packing: "รายงานสรุปยอดการแพ็คสินค้า",
            partner: "บริษัทคู่ค้า",
            product: "สินค้า",
            storage: "ตำแหน่งจัดเก็บสินค้า",
            promotion: "โปรโมชั่น",
        },
		history_type: "ประเภท",
        created_at: "วันที่",
        staff: "พนักงาน",
        bill_number: "หมายเลขบิล",
        bill_image: "รูปภาพบิล",
        threshold: "จำนวนต่ำสุดที่สามารถสั่งซื้อได้",

        inventory_main: "คลังสินค้าหลัก",
        inventory_src: "คลังสินค้าต้นทาง",
        inventory_dst: "คลังสินค้าปลายทาง",
        inventoryin_list: "รายการสินค้านำเข้า",
        inventoryout_list: "รายการเบิกสินค้า",
        inventorytransfer_list: "รายการย้ายสินค้า",
        // Prodcut
        product_name: "ชื่อสินค้า",
        partner: "บริษัทคู่ค้า",
        package_name: "หน่วยสินค้า",
        barcode: "Barcode",
        product_width: "กว้าง",
        product_height: "ยาว",
        product_depth: "สูง",
        product_weight: "น้ำหนัก",
		product_pn:"SKU",

        // Partner
        company_name: "ชื่อบริษัท",
        address: "ที่อยู่",
        contact_name: "ชื่อผู้ติดต่อ",
        contact_tel: "เบอร์โทรผู้ติดต่อ",

        // Inventory
        inventory_in: "เพิ่ม",
        inventory_out: "เบิก",

        amount: "จำนวน",
        cost: "ราคา",
        note: "หมายเหตุ",
        product: "สินค้า",
        product_promotion: "สินค้าและโปรโมชั่น",
        corporate: "บริษัท",
        storage: "ตำแหน่งจัดเก็บสินค้า",
        balance: "คงเหลือ",
        overall_amount: "จำนวนทั้งหมด",
        overall_cost: "มูลค่า",
        taxid: "หมายเลขผู้เสียภาษี",
        tel: "เบอร์โทรศัพท์",
        email: "อีเมล์",
        storage_name: "ชื่อ",
        storage_desc: "คำอธิบาย",
        x: "X",
        y: "Y",

        width: "กว้าง (cm)",
        height: "สูง (cm)",
        depth: "ลึก (cm)",
        weight: "น้ำหนัก (g)",
        cost: "ต้นทุน",
    },

    // =================================================================
    // Backoffice Module
    // =================================================================

        backoffice: "ระบบจัดการร้านค้า",
        orders: "รายการสั่งซื้อ",
        products: "สินค้า",
        product_random: "สินค้าสุ่ม",
        packings: "การจัดส่ง",
        order_return: "สินค้าตีกลับ",
        payments: "การชำระเงิน",
        reports: "รายงาน",
        customer_information: "ข้อมูลลูกค้า",
        customer: "ลูกค้า",
        platform_connect: "เชื่อมต่อแพลตฟอร์ม",

        product_information: "ข้อมูลสินค้า",

		seller_note:"หมายเหตุ",


        order_form: "สั่งซื้อสินค้า",
        order_status: "สถานะ",
        order_number: "หมายเลขสั่งซื้อ",
        order_user: "พนักงาน",
        order_detail: "รายละเอียดการสั่งซื้อ",
        order_form: "สร้างรายการสั่งซื้อ",
        order_count: "จำนวนรายการสั่งซื้อ",

		// order_status_unpaid : "รอชำระเงิน",
		// order_status_awaiting_shipment: "รอจัดส่ง",
		// order_status_awaitingcollection : "รอขนส่งเข้ารับสินค้า",
		// order_status_partiallyshipping  : "จัดส่งบางส่วน",
		// order_status_intransit : "กำลังขนส่ง",
		// order_status_delivered : "จัดส่งแล้ว",
		// order_status_completed : "สำเร็จ",
		// order_status_cancelled : "ยกเลิก",

		order_status_unpaid : "รอชำระเงิน",
		order_status_awaiting_shipment: "รอตัดรอบส่งสินค้า",
		order_status_awaitingcollection : "รอส่งสินค้า",
		order_status_partiallyshipping  : "จัดส่งบางส่วน",
		order_status_intransit : "กำลังขนส่ง",
		order_status_delivered : "จัดส่งแล้ว",
		order_status_completed : "สำเร็จ",
		order_status_claim : "เคลมสินค้า",
		order_status_cancelled : "ยกเลิก",
		order_status_returned : "สินค้าตีกลับ",
		order_status_claimed: "เคลมสินค้า",
        order_status_returning : "อยู่ระหว่างตีกลับ (Platform)",
        order_status_intransit_completed : "กำลังขนส่ง , สำเร็จ",

		payment_slip : "สลิปการชำระเงิน",
		payment_channel : "ช่องทางการชำระเงิน",
		payment_method : "ช่องทางการชำระเงิน",
		payment_check : "ตรวจสอบการชำระเงิน",

		platform : "Platform",
        sale_channel: "ช่องทางการขาย",
        sale_channel_type: "ประเภทช่องทางการขาย",
		recipient_name: "ชื่อผู้รับ",
		recipent_address: "ที่อยู่ผู้รับ",
		recipent_district: "ตำบล / แขวง",
		recipent_city: "อำเภอ / เขต",
		recipent_province: "จังหวัด",
		recipent_zipcode: "รหัสไปรษณีย์",
		recipient_phone: "เบอร์โทรผู้รับ",

		report_by_team: "รายงานตามทีมขาย",
		report_by_sale_channel: "รายงานตามช่องทางการขาย",
		report_by_user: "รายงานตามพนักงานขาย",
		report_by_product: "รายงานตามสินค้า",
		report_by_user_product: "รายงานตามพนักงานขายและสินค้า",
		report_by_sale_channel_and_product: "รายงานต้นทุน / กำไรตามสินค้า",
		report_wms_summary:"รายงานสรุปจำนวนสินค้า",
		report_wms_product_summary:"รายงานสรุปจำนวนสินค้าแยกตามสินค้าและโปรโมชั่น",
		report_wms_field_summary:"รายงานสรุปจำนวนสินค้าแยกตามประเภทข้อมูล",
		report_commission:"รายงานค่าคอมมิชชั่นตัวแทน",
		report_order_return:"รายงานสินค้าตีกลับ",

		time_from: "เริ่มต้น",
		time_to: "สิ้นสุด",
		valid_from: "วันเริ่มต้นใช้งาน",
		valid_to: "วันสิ้นสุดใช้งาน",
		all: "ทั้งหมด",
		type: "ประเภท",
		bank: "ธนาคาร",
		bank_account: "เลขที่บัญชี",
		bank_branch: "สาขา",
		detail: "รายละเอียด",
		product: "สินค้า",
		price: "ราคา",
		image: "รูปภาพ",
		tag: "Tags",
		quantity: "จำนวน",
		product_form:"จัดการสินค้า",
		product_code:"รหัสสินค้า",
		product_category:"หมวดหมู่สินค้า",
		is_comboset: "เป็นชุดสินค้า",
		team: "ทีมขาย",
		department: "แผนก",
		fname: "ชื่อ",
		lname: "นามสกุล",
		nick_name: "ชื่อเล่น",
		password_old: "รหัสผ่านเดิม",
		password: "รหัสผ่าน",
		password_confirm: "ยืนยันรหัสผ่าน",
		password_not_match: "รหัสผ่านไม่ตรงกัน",
		packing_number: "หมายเลขตัดรอบแพ็ค",
		packing_user: "ผู้ตัดรอบ",
		packing_date: "เวลาที่ตัดรอบ",
		line_packing: "สายที่แพ็ค",
		please_select_sale_channel: "กรุณาเลือกช่องทางการขาย",
		please_select_payment_method: "กรุณาเลือกช่องทางการชำระเงิน",
		payment_success: "ชำระเงินนถูกต้อง",
		payment_fail: "ชำระเงินไม่ถูกต้อง",
		shipping: "ส่งสินค้า",
		shipping_provider: "บริษัทขนส่ง",
		barcode: "บาร์โค้ด",
		scanbarcode: "คลิ๊กเพื่อสแกน Barcode",
        product_pn: "รหัสสินค้า",
		tracking_number:"หมายเลขพัสดุ",
		order_information:"ข้อมูลรายการสั่งซื้อ",
		product_image:"รูปภาพสินค้า",
		product_name:"ชื่อสินค้า",
		product_pickup:"จำนวนสินค้า",
		cancel_confirm:"ยืนยันการยกเลิกรายการสั่งซื้อ",
		cancel_confirm_question:"คุณต้องการยกเลิกรายการสั่งซื้อหมายเลข",
		cancel_order_success: "ยกเลิกรายการสั่งซื้อเรียบร้อยแล้ว",
		please_select_cancel_reason: "กรุณาเลือกประเภทเหตุผลที่ยกเลิก",
		please_input_cancel_reason: "กรุณากรอกเหตุผลที่ยกเลิก",

		shipping_return: "คืนสินค้า",


		user_group:"กลุ่มผู้่ใช้งาน",


		// Report
		order_amount :"จำนวนรายการสั่งซื้อ",
		payment_amount:"รวมจำนวนเงิน",
		payment_amount_net:"รวมจำนวนเงิน (สุทธิ)",
		product_amount:"จำนวนสินค้า",
		discount:"ส่วนลด",
		payment_method_type:"ประเภทการชำระเงิน",
		sort_type:"การเรียงลำดับ",
		change_tracking_success :"เปลี่ยนหมายเลขพัสดุสำเร็จ",
		change_shipping_success: "เปลี่ยนขนส่งสำเร็จ",
		price_per_unit:"ราคาต่อหน่วย",
		platform_order_id:"หมายเลขสั่งซื้อ Platform (OrderID)",
		processing:"กำลังประมวลผล...",
		packing_order_back_day :"ตัดรอบย้อนหลัง (วัน)",
        product_promotion: "สินค้าและโปรโมชั่น",
		coupon: "คูปอง",
		coupon_discount_type : "ประเภทส่วนลด",
		coupon_amount_mininum : "จำนวนขั้นต่ำ",
		coupon_discount_value : "ส่วนลด",
		date : "วันที่",
		product_name : "ชื่อสินค้า",
		amount_packing : "จำนวนที่แพ็ค",
		per_each_cost : "ราคาต้นทุนต่อหน่วย",
		per_each_promotion_price : "ราคาขายต่อหน่วย",
		sum_cost : "ต้นทุนรวม",
		sum_sale_price : "ยอดขายรวม",
		sum_shipping_cost : "ค่าขนส่งรวม",
		sale_amount : "จำนวนรายการขาย",
		profit : "กำไร",
		sale_channel_name : "ช่องทางการขาย",
		shipping_cost : "ต้นทุนค่าขนส่ง",
		return_success : "ตีกลับสินค้าสำเร็จ",
		return_fail : "ตีกลับสินค้าผิดพลาด",
		shipping_quantity : "จำนวนสินค้าที่จัดส่ง",
		return_good_quantity: "สินค้าดี",
		return_broken_quantity: "ชำรุด",
		return_lost_quantity: "สูญหาย",
		return_other_reson_quantity: "อื่นๆ",
        po_form: "ใบสั่งซื้อ",
        running_from: "หมายเลขเริ่มต้น",
        running_to: "หมายเลขสิ้นสุด",

    member: {
        line_user_id: "LINE User ID",
        birthday: "วันเกิด",
        sex: "เพศ",
        total_spending: "ยอดซื้อรวม",
        address: "ที่อยู่",
        province: "จังหวัด",
        district: "อำเภอ",
        subdistrict: "ตำบล",
        postcode: "รหัสไปรษณีย์",
        coupons: "คูปอง",
        coupon_code: "รหัสคูปอง",
        coupon_status: "สถานะ",
        used: "ใช้แล้ว",
        unused: "ยังไม่ใช้",
        created_at: "วันที่สร้าง",
        used_at: "วันที่ใช้",
        no_coupons: "ไม่พบคูปอง",
        error_loading_coupons: "เกิดข้อผิดพลาดในการโหลดคูปอง"
    },

    webcam_recording: "การบันทึกจากเว็บแคม",
    waiting_for_packaging: "รอแพ็ค",
    camera_settings: "ตั้งค่ากล้อง",
    select_camera: "เลือกกล้อง",
    connect_camera: "เชื่อมต่อกล้อง",
    camera_preview: "ตัวอย่างกล้อง",
    no_camera_found: "ไม่พบกล้อง",
    camera_not_supported: "เบราว์เซอร์ของคุณไม่รองรับการใช้งานเว็บแคม",
    start_recording: "เริ่มบันทึก",
    stop_recording: "หยุดบันทึก",
    recording_in_progress: "กำลังบันทึก...",
    recording_stopped: "หยุดบันทึกแล้ว",
    upload_recording: "อัพโหลดการบันทึก",
    recording_uploaded: "อัพโหลดการบันทึกสำเร็จ",
    error_uploading_recording: "เกิดข้อผิดพลาดในการอัพโหลดการบันทึก",
    no_recording_available: "ไม่มีการบันทึกที่สามารถใช้งานได้",
    invalid_file_type: "ประเภทไฟล์ไม่ถูกต้อง",
    file_too_large: "ไฟล์มีขนาดใหญ่เกินไป",
    recording_duration: "ระยะเวลาการบันทึก",
    max_recording_duration: "ระยะเวลาการบันทึกสูงสุดคือ 5 นาที",
    recording_timer: "ตัวจับเวลา",
    start_timer: "เริ่มจับเวลา",
    stop_timer: "หยุดจับเวลา",
    reset_timer: "รีเซ็ตตัวจับเวลา",
    camera_device: "อุปกรณ์กล้อง",
    video_quality: "คุณภาพวิดีโอ",

    // =================================================================
    // Platform Statement Module
    // =================================================================
    platform_statement: {
        name: "งบการเงิน Platform",
        menu: "งบการเงิน Platform",
        list: "รายการงบการเงิน",
        upload: "อัพโหลดงบการเงิน",
        detail: "รายละเอียดงบการเงิน",
        summary: "รายงานสรุป",

        statement_number: "เลขที่งบการเงิน",
        statement_date: "วันที่งบการเงิน",
        settlement_date: "วันที่โอนเงิน",
        platform: "แพลตฟอร์ม",
        platform_shop_id: "รหัสร้านค้า",

        total_orders: "จำนวนออเดอร์",
        total_sales_amount: "ยอดขายรวม",
        total_platform_fee: "ค่าธรรมเนียม Platform",
        total_commission: "ค่าคอมมิชชั่น",
        total_shipping_fee: "ค่าจัดส่ง",
        total_other_fee: "ค่าใช้จ่ายอื่นๆ",
        net_amount: "ยอดรับสุทธิ",

        platform_order_id: "รหัสออเดอร์ Platform",
        related_order_id: "รหัสออเดอร์ที่เกี่ยวข้อง",
        order_date: "วันที่สั่งซื้อ",
        order_created_time: "เวลาที่สร้างออเดอร์",
        order_settled_time: "เวลาที่ปิดออเดอร์",
        transaction_type: "ประเภทธุรกรรม",
        currency: "สกุลเงิน",
        order_amount: "ยอดสั่งซื้อ",
        total_revenue: "รายได้รวม",

        // Seller Discounts
        subtotal_after_seller_discounts: "ยอดหลังหักส่วนลดผู้ขาย",
        subtotal_before_discounts: "ยอดก่อนหักส่วนลด",
        seller_discounts: "ส่วนลดผู้ขาย",

        // Refunds
        refund_subtotal_after_seller_discounts: "คืนเงินหลังหักส่วนลดผู้ขาย",
        refund_subtotal_before_seller_discounts: "คืนเงินก่อนหักส่วนลดผู้ขาย",
        refund_of_seller_discounts: "คืนส่วนลดผู้ขาย",

        // Fees
        platform_fee: "ค่าธรรมเนียม Platform",
        commission: "คอมมิชชั่น",
        transaction_fee: "ค่าธรรมเนียมการทำธุรกรรม",
        credit_card_installment_fee: "ค่าธรรมเนียมผ่อนบัตรเครดิต",
        payment_fee: "ค่าธรรมเนียมการชำระเงิน",

        // Shipping
        shipping_fee: "ค่าจัดส่ง",
        seller_shipping_fee: "ค่าจัดส่งผู้ขาย",
        actual_shipping_fee: "ค่าจัดส่งจริง",
        platform_shipping_fee_discount: "ส่วนลดค่าจัดส่งจาก Platform",
        customer_shipping_fee: "ค่าจัดส่งลูกค้า",
        refund_customer_shipping_fee: "คืนค่าจัดส่งลูกค้า",
        actual_return_shipping_fee: "ค่าจัดส่งคืนจริง",
        shipping_fee_subsidy: "เงินอุดหนุนค่าจัดส่ง",
        seller_shipping_fee_discount: "ส่วนลดค่าจัดส่งผู้ขาย",

        // Affiliate
        affiliate_commission: "คอมมิชชั่นพันธมิตร",
        affiliate_commission_before_pit: "คอมมิชชั่นพันธมิตรก่อนหักภาษี",
        personal_income_tax_withheld: "ภาษีหัก ณ ที่จ่าย",
        affiliate_partner_commission: "คอมมิชชั่นพาร์ทเนอร์",
        affiliate_shop_ads_commission: "คอมมิชชั่นโฆษณาร้านค้า",
        affiliate_commission_deposit: "เงินฝากคอมมิชชั่นพันธมิตร",
        affiliate_commission_refund: "คืนคอมมิชชั่นพันธมิตร",

        // Service Fees
        sfp_service_fee: "ค่าบริการ SFP",
        live_specials_service_fee: "ค่าบริการ Live Specials",
        voucher_xtra_service_fee: "ค่าบริการ Voucher Xtra",
        eams_program_service_fee: "ค่าบริการโปรแกรม EAMS",
        brand_crazy_deals_flash_sale_fee: "ค่าธรรมเนียม Brand Crazy Deals Flash Sale",
        bonus_cashback_service_fee: "ค่าบริการโบนัสแคชแบ็ค",
        tiktok_paylater_program_fee: "ค่าธรรมเนียมโปรแกรม TikTok PayLater",
        commerce_growth_fee: "ค่าธรรมเนียมการเติบโตทางการค้า",
        infrastructure_fee: "ค่าโครงสร้างพื้นฐาน",
        campaign_resource_fee: "ค่าทรัพยากรแคมเปญ",
        other_fee: "ค่าใช้จ่ายอื่นๆ",

        // Adjustment
        adjustment: "การปรับยอด",
        adjustment_amount: "จำนวนเงินปรับยอด",

        // Customer Payment
        customer_payment: "การชำระเงินของลูกค้า",
        customer_refund: "คืนเงินลูกค้า",

        // Vouchers
        seller_co_funded_voucher_discount: "ส่วนลดคูปองร่วมทุนผู้ขาย",
        refund_of_seller_co_funded_voucher: "คืนคูปองร่วมทุนผู้ขาย",
        platform_discounts: "ส่วนลด Platform",
        refund_of_platform_discounts: "คืนส่วนลด Platform",
        platform_co_funded_voucher_discounts: "ส่วนลดคูปองร่วมทุน Platform",
        refund_of_platform_co_funded_voucher: "คืนคูปองร่วมทุน Platform",

        // Additional Info
        estimated_package_weight: "น้ำหนักพัสดุโดยประมาณ",
        actual_package_weight: "น้ำหนักพัสดุจริง",
        shopping_center_items: "สินค้า Shopping Center",
        customer_bank_for_payment: "ธนาคารลูกค้าสำหรับชำระเงิน",
        product_name: "ชื่อสินค้า",
        quantity: "จำนวน",
        sku: "รหัสสินค้า (SKU)",

        upload_file: "อัพโหลดไฟล์ Excel",
        select_platform: "เลือกแพลตฟอร์ม",
        drag_drop_file: "ลากไฟล์มาวางที่นี่ หรือคลิกเพื่อเลือกไฟล์",
        supported_formats: "รองรับไฟล์: .xlsx, .xls",
        max_file_size: "ขนาดไฟล์สูงสุด: 50MB",

        upload_success: "อัพโหลดงบการเงินสำเร็จ",
        upload_fail: "อัพโหลดงบการเงินไม่สำเร็จ",
        delete_success: "ลบงบการเงินสำเร็จ",
        delete_fail: "ลบงบการเงินไม่สำเร็จ",
        delete_confirm: "ยืนยันการลบงบการเงิน",
        delete_confirm_text: "คุณต้องการลบงบการเงินนี้หรือไม่?",

        export_excel: "ส่งออก Excel",
        export_pdf: "ส่งออก PDF",
        generate_report: "สร้างรายงาน",

        search_by_statement_number: "ค้นหาด้วยเลขที่งบการเงิน",
        filter_by_platform: "กรองตามแพลตฟอร์ม",
        filter_by_date: "กรองตามวันที่",

        uploaded_by: "อัพโหลดโดย",
        uploaded_at: "อัพโหลดเมื่อ",
        uploaded_filename: "ชื่อไฟล์ที่อัพโหลด",

        financial_summary: "สรุปการเงิน",
        order_details: "รายละเอียดออเดอร์",

        type_order: "ออเดอร์",
        type_refund: "คืนเงิน",
        type_adjustment: "ปรับยอด",

        all_platforms: "แพลตฟอร์มทั้งหมด",

        no_data: "ไม่พบข้อมูล",
        loading: "กำลังโหลดข้อมูล...",

        date_range: "ช่วงเวลา",
        from_date: "จากวันที่",
        to_date: "ถึงวันที่",

        total_statements: "จำนวนงบการเงิน",
        total_fees: "ค่าธรรมเนียมรวม",
        fee_percentage: "เปอร์เซ็นต์ค่าธรรมเนียม",

        // Breakdown sections
        revenue_breakdown: "รายละเอียดรายได้",
        fee_breakdown: "รายละเอียดค่าธรรมเนียม",
        adjustment_breakdown: "รายละเอียดการปรับยอด",

        // Fee breakdown items
        total_transaction_fee: "ค่าธรรมเนียมการทำธุรกรรมรวม",
        total_affiliate_commission: "คอมมิชชั่นพันธมิตรรวม",
        total_affiliate_shop_ads: "คอมมิชชั่นโฆษณาร้านค้ารวม",
        total_service_fees: "ค่าบริการรวม",

        // Adjustment breakdown items
        total_adjustment: "การปรับยอดรวม",
        shipping_fee_adjustment: "การปรับยอดค่าจัดส่ง",
        logistics_reimbursement: "เงินชดเชยค่าขนส่ง",
        platform_compensation: "เงินชดเชยจาก Platform",
        platform_penalty: "ค่าปรับจาก Platform",
        other_adjustments: "การปรับยอดอื่นๆ",

        view_details: "ดูรายละเอียด",
        back_to_list: "กลับไปหน้ารายการ",

        lz_premium_package: "Premium Package",
        lz_payment_service_fee: "ค่าบริการชำระเงิน",
        lz_coupon_service_fee: "ค่าคูปองส่งเสริมการขาย",
        lz_commission_fee: "ธรรมเนียมการขายสินค้า",

        sp_adj_shipping_claim : "เคลมค่าจัดส่ง",
        sp_adj_other: "อื่นๆ",
        sp_adj_refund: "การคืนเงิน/คืนสินค้าหลลังคำสั่งซื้อสำเร็จ",
        sp_adj_shipping: "การปรับปรุงเกี่ยวกับขนส่ง",
        sp_shipping : "การจัดส่ง",
    }
};
